import { render } from "./Index.vue?vue&type=template&id=e2b28ba2"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Farmer/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2b28ba2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2b28ba2', __exports__)) {
    console.log('reload')
    api.reload('e2b28ba2', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=e2b28ba2", () => {
    console.log('re-render')
    api.rerender('e2b28ba2', render)
  })

}


export default __exports__